import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { ConfigManagerService } from '../../../shared/services/config-manager.service';

@Injectable({
  providedIn: "root",
})
export class ProdutoService {
  constructor(private http: HttpClient, private configManagerService: ConfigManagerService) {}

  getProductsEcommerce(codigoCatalogo: string) {
    const api = this.configManagerService.obterConfig()?.API_PRODUCTS;

    return this.http
      .get(`${api}/catalogo/${codigoCatalogo}`)
      .pipe(catchError((err) => throwError(() => err)));
  }
}
